// --- DADOS DO CRONOGRAMA GERAL ---
export const scheduleData = [
    // SEGUNDA-FEIRA
    { type: 'Community Time', day: 'Segunda-feira', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '6B', professor: 'LUIZA LIMEIRA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '6C', professor: 'TATIANA COSTA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '7A', professor: 'MICHELE LIMA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '8A', professor: 'MARÍLIA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '8B', professor: 'ALEXANDRA BORGES' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '8D', professor: 'PENDENTE' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '9B', professor: 'TATIANA COSTA' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '9C', professor: 'VINÍCIUS SUZUKI' },
    { type: 'Community Time', day: 'Segunda-feira', turma: '9D', professor: 'LEANDRO MELLO' },

    // TERÇA-FEIRA
    { type: 'Community Time', day: 'Terça-feira', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Community Time', day: 'Terça-feira', turma: '6B', professor: 'TATIANA COSTA' },
    { type: 'Community Time', day: 'Terça-feira', turma: '6C', professor: 'CAROLINA NOVAES' },
    { type: 'Community Time', day: 'Terça-feira', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Community Time', day: 'Terça-feira', turma: '7A', professor: 'PATRICK MARTINS' },
    { type: 'Community Time', day: 'Terça-feira', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Community Time', day: 'Terça-feira', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Community Time', day: 'Terça-feira', turma: '8A', professor: 'LUCINDA' },
    { type: 'Community Time', day: 'Terça-feira', turma: '8B', professor: 'ALEXANDRA BORGES' },
    { type: 'Community Time', day: 'Terça-feira', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Community Time', day: 'Terça-feira', turma: '8D', professor: 'LEONARDO KING' },
    { type: 'Community Time', day: 'Terça-feira', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Community Time', day: 'Terça-feira', turma: '9B', professor: 'TAINÁ LOPES' },
    { type: 'Community Time', day: 'Terça-feira', turma: '9C', professor: 'VINÍCIUS SUZUKI' },
    { type: 'Community Time', day: 'Terça-feira', turma: '9D', professor: 'LEANDRO MELLO' },

    // QUARTA-FEIRA
    { type: 'Community Time', day: 'Quarta-feira', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '6B', professor: 'LUIZA LIMEIRA' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '6C', professor: 'TATIANA COSTA' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '7A', professor: 'ANDRÉ' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '8A', professor: 'LEANDRO MELLO' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '8B', professor: 'ALEXANDRA BORGES' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '8D', professor: 'LEONARDO KING' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '9B', professor: 'TAINÁ LOPES' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '9C', professor: 'VINÍCIUS SUZUKI' },
    { type: 'Community Time', day: 'Quarta-feira', turma: '9D', professor: 'GUSTAVO BRITO' },

    // QUINTA-FEIRA
    { type: 'Community Time', day: 'Quinta-feira', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '6B', professor: 'LUIZA LIMEIRA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '6C', professor: 'CAROLINA NOVAES' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '7A', professor: 'RENATA BULCÃO' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '8A', professor: 'LUCINDA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '8B', professor: 'PENDENTE' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '8D', professor: 'TATIANA COSTA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '9B', professor: 'TAINÁ LOPES' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '9C', professor: 'NATÁLIA BARDELLA' },
    { type: 'Community Time', day: 'Quinta-feira', turma: '9D', professor: 'LEANDRO MELLO' },

    // SEXTA-FEIRA
    { type: 'Community Time', day: 'Sexta-feira', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '6B', professor: 'LUIZA LIMEIRA' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '6C', professor: 'PENDENTE' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '7A', professor: 'PEDRO AQUINO' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '8A', professor: 'ANDRÉ' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '8B', professor: 'ALEXANDRA BORGES' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '8D', professor: 'MARÍLIA' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '9B', professor: 'PAULA CARDOSO' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '9C', professor: 'VINÍCIUS SUZUKI' },
    { type: 'Community Time', day: 'Sexta-feira', turma: '9D', professor: 'LEANDRO MELLO' },

    // CYCLE TESTS
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '6A', professor: 'MARIA BÁRBARA BRANCO' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '6B', professor: 'LUIZA LIMEIRA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '6C', professor: 'TATIANA COSTA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '6D', professor: 'LUANA BENEVIDES' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '7A', professor: 'PENDENTE' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '7B', professor: 'ANA ALQUERES' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '7C', professor: 'ALEXSANDRA OLIVEIRA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '8A', professor: 'TATIANA COSTA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '8B', professor: 'ALEXANDRA BORGES' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '8C', professor: 'JAMIL SANTOS' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '8D', professor: 'DEBORAH OLIVEIRA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '9A', professor: 'DELNICE PEREIRA' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '9B', professor: 'TAINÁ LOPES' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '9C', professor: 'VINÍCIUS SUZUKI' },
    { type: 'Cycle Tests', day: 'Dia de Teste', turma: '9D', professor: 'LEANDRO MELLO' }
];

export const dayOrder = {
    'Segunda-feira': 1,
    'Terça-feira': 2,
    'Quarta-feira': 3,
    'Quinta-feira': 4,
    'Sexta-feira': 5,
    'Dia de Teste': 6
};

export const turmas = ['6A', '6B', '6C', '6D', '7A', '7B', '7C', '8A', '8B', '8C', '8D', '9A', '9B', '9C', '9D'];
export const weekdays = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira'];
export const turmas67 = ['6A', '6B', '6C', '6D', '7A', '7B', '7C'];
export const turmas89 = ['8A', '8B', '8C', '8D', '9A', '9B', '9C', '9D'];

export const getProfessor = (type, day, turma) => {
    const entry = scheduleData.find(s => s.type === type && (day ? s.day === day : true) && s.turma === turma);
    return entry ? entry.professor : '-';
};

// --- DADOS ESPECÍFICOS DO SCHOOL SYNC VA ---
export const TRIMESTERS = [
  { id: 1, name: "1º Trimestre", start: "2026-02-05", end: "2026-05-15", months: [1, 2, 3, 4] },
  { id: 2, name: "2º Trimestre", start: "2026-05-18", end: "2026-09-04", months: [4, 5, 6, 7, 8] },
  { id: 3, name: "3º Trimestre", start: "2026-09-08", end: "2026-12-11", months: [8, 9, 10, 11] }
];

export const SUBJECTS = [
  "Língua Portuguesa", "Matemática", "História (History)", "Geografia (Geography)",
  "Language and Arts", "Ciências da Natureza (Science)", "Biologia", "Química",
  "Física", "Filosofia", "Sociologia", "Literatura", "Arte", "Physical Education",
  "Public Speaking", "Drama", "Creative Tech", "Music"
];

export const RULES = [
  { id: '1', grade: 6, maxPerDay: 2, maxPerWeek: 4, maxHeavyPerWeek: 1, allowOverflow: true },
  { id: '2', grade: 7, maxPerDay: 2, maxPerWeek: 4, maxHeavyPerWeek: 1, allowOverflow: true },
  { id: '3', grade: 8, maxPerDay: 2, maxPerWeek: 4, maxHeavyPerWeek: 1, allowOverflow: true },
  { id: '4', grade: 9, maxPerDay: 2, maxPerWeek: 4, maxHeavyPerWeek: 1, allowOverflow: true }
];

export const INITIAL_ASSESSMENTS = [
  { 
    id: '1', 
    startDate: '2026-03-05', 
    endDate: '2026-03-05', 
    startTime: '08:00', 
    endTime: '08:50', 
    title: 'Avaliação Diagnóstica', 
    classId: '6A', 
    classIds: ['6A'], 
    subject: 'Matemática',
    weight: 'medium', 
    status: 'confirmed', 
    teacherId: 'mock-teacher', 
    teacherName: 'Professor Exemplo' 
  },
  { 
    id: '2', 
    startDate: '2026-03-10', 
    endDate: '2026-03-10', 
    startTime: '10:15', 
    endTime: '11:05', 
    title: 'Simulado Ciclo 1', 
    classId: '8A', 
    classIds: ['8A'], 
    subject: 'Língua Portuguesa',
    weight: 'heavy', 
    status: 'pending_exception', 
    teacherId: 'mock-teacher', 
    teacherName: 'Professor Exemplo' 
  }
];
